import React, { useEffect, useRef } from 'react';
import { startWaveTrail } from './wave-trail';

export default function WaveTrail() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (canvasRef.current) return startWaveTrail(canvasRef.current);
  }, []);
  return <canvas ref={canvasRef} className="wave-trail" aria-hidden="true" />;
}
